export default "__VITE_ASSET__6_rPQ9V2__"